import React from 'react';
import { Box, Tooltip } from '@mui/material';

const BADGE_CONFIG = {
  over_budget: {
    label: 'A little over budget',
    color: 'warning'
  },
  availability_conflict: {
    label: 'Might not be available on your date',
    color: 'info'
  }
};

/**
 * Outlined pill labels (not Mui Chip). Each badge is a list item in a column so
 * we avoid row flex + align stretch. The pill uses width: max-content (not
 * min-content, which can resolve to a very narrow box and force many wrapped
 * lines / a huge height).
 */
function SupplierBadges({ badges = [] }) {
  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <Box
      component="ul"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        gap: 0.5,
        maxWidth: '100%',
        m: 0,
        p: 0,
        listStyle: 'none',
        minHeight: 0
      }}
    >
      {badges.map((badge, index) => {
        const config = BADGE_CONFIG[badge];
        if (!config) {
          return null;
        }
        const paletteKey = config.color;
        return (
          <Box
            key={index}
            component="li"
            sx={{ p: 0, m: 0, minHeight: 0, flexShrink: 0, display: 'block' }}
          >
            <Tooltip title={config.label} arrow>
              <Box
                component="span"
                sx={(theme) => ({
                  display: 'inline-block',
                  width: 'max-content',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                  border: '1px solid',
                  borderColor: theme.palette[paletteKey].main,
                  color: theme.palette[paletteKey].main,
                  backgroundColor: 'transparent',
                  borderRadius: 1,
                  px: 0.75,
                  py: 0.4,
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  lineHeight: 1.3,
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  boxShadow: 'none',
                  minHeight: 0
                })}
              >
                {config.label}
              </Box>
            </Tooltip>
          </Box>
        );
      })}
    </Box>
  );
}

export default SupplierBadges;
